var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2Bauprojekt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2-bauprojekt",
    "data-name": "2-bauprojekt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.029,
    height: 83.03,
    viewBox: "0 0 83.029 83.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1957",
    "data-name": "Rechteck 1957",
    width: 83.029,
    height: 83.03,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_663",
    "data-name": "Gruppe 663",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4108",
    "data-name": "Pfad 4108",
    d: "M82.684,41.93A40.754,40.754,0,1,1,41.929,1.176,40.754,40.754,0,0,1,82.684,41.93",
    transform: "translate(-0.415 -0.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4109",
    "data-name": "Pfad 4109",
    d: "M41.514,83.03A41.515,41.515,0,1,1,83.03,41.515,41.562,41.562,0,0,1,41.514,83.03m0-81.508A39.994,39.994,0,1,0,81.508,41.515,40.039,40.039,0,0,0,41.514,1.521",
    transform: "translate(0)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4110",
    "data-name": "Pfad 4110",
    d: "M59.52,69.285H32.812V33.333a5.64,5.64,0,0,1,3.962-5.4L57.585,21.38A1.488,1.488,0,0,1,59.52,22.8ZM34.333,67.763H58V22.846L37.231,29.383a4.124,4.124,0,0,0-2.9,3.95Z",
    transform: "translate(-11.586 -7.525)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4111",
    "data-name": "Pfad 4111",
    d: "M87.176,72.984H71.746V33.4A1.564,1.564,0,0,1,72.515,32a1.6,1.6,0,0,1,1.568-.024l10.636,5.909c1.5.853,2.457,3.114,2.457,5.764ZM73.267,71.462H85.656V43.654c0-2.285-.846-3.962-1.682-4.439L73.337,33.306a.154.154,0,0,0-.06.016.237.237,0,0,0-.01.078Z",
    transform: "translate(-25.334 -11.224)",
    fill: "#00c713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4112",
    "data-name": "Pfad 4112",
    d: "M74.183,94.641h-45.9a.761.761,0,0,1,0-1.521h45.9a.761.761,0,1,1,0,1.521",
    transform: "translate(-9.719 -32.881)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4113",
    "data-name": "Pfad 4113",
    d: "M45.322,70.763a.951.951,0,0,1-.951-.951V67.53a.951.951,0,1,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V61.064a.951.951,0,1,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.085a.951.951,0,0,1-.951-.951V54.979a.951.951,0,0,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V48.514a.951.951,0,1,1,1.9,0V50.8a.951.951,0,0,1-.951.951",
    transform: "translate(-15.668 -16.795)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4114",
    "data-name": "Pfad 4114",
    d: "M52.936,70.763a.951.951,0,0,1-.951-.951V67.53a.951.951,0,1,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V61.064a.951.951,0,1,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.085a.951.951,0,0,1-.951-.951V54.979a.951.951,0,0,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V48.514a.951.951,0,1,1,1.9,0V50.8a.951.951,0,0,1-.951.951",
    transform: "translate(-18.356 -16.795)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4115",
    "data-name": "Pfad 4115",
    d: "M61.312,70.763a.951.951,0,0,1-.951-.951V67.53a.951.951,0,0,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V61.064a.951.951,0,1,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.085a.951.951,0,0,1-.951-.951V54.979a.951.951,0,0,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V48.514a.951.951,0,1,1,1.9,0V50.8a.951.951,0,0,1-.951.951",
    transform: "translate(-21.314 -16.795)",
    fill: "#00467d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4116",
    "data-name": "Pfad 4116",
    d: "M82.093,70.763a.951.951,0,0,1-.951-.951V67.53a.951.951,0,0,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V61.064a.951.951,0,1,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.085a.951.951,0,0,1-.951-.951V54.979a.951.951,0,0,1,1.9,0v2.282a.951.951,0,0,1-.951.951m0-6.466a.951.951,0,0,1-.951-.951V48.514a.951.951,0,1,1,1.9,0V50.8a.951.951,0,0,1-.951.951",
    transform: "translate(-28.652 -16.795)",
    fill: "#00c713"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Bauprojekt);
export default __webpack_public_path__ + "static/media/2-bauprojekt.0b081ae4496d8ac7c8266e69859bd990.svg";
export { ForwardRef as ReactComponent };